// extracted by mini-css-extract-plugin
module.exports = {"productionRateModal":"productionRateModal_productionRateModal__pcCKB"};